import { UploadFile } from "antd";
import { t } from "i18next";
import { onError } from "src/common/onError";

import { msgQueueStore } from "../MsgQueue";
import { checkFileSize } from "./checkFileSize";
import { isAccept } from "./isAccept";

export const filterClipboardData = (
  uploadData: File[],
  maxCount: number | undefined,
  fileList: UploadFile[],
  maxSize: number | undefined,
  accept: string | undefined,
): File[] => {
  try {
    let files = uploadData.filter((file) => {
      const result = isAccept(file, accept);
      if (!result)
        msgQueueStore.add({
          type: "error",
          message: t("Invalid data format:", { file: file.name }),
        });
      return result;
    });
    if (maxCount) {
      files = files.slice(0, maxCount - fileList.length);
    }

    if (maxSize) {
      files.forEach((file) => {
        checkFileSize(file, maxSize);
      });
    }
    return files;
  } catch (error) {
    onError(error);
    return [];
  }
};
